// Don't apply 'HeadingBuilder' for this component's 'Tippy content' ('submit' field)
import React from 'react';
import * as Constants from '../constants';
import HeadingBuilder from '../components/HeadingBuilder';
import { usePhrasing } from "../hooks/useSkuUtils";
import { RadioButton } from "./RadioButton";
import 'tippy.js/dist/tippy.css';
import { useTranslation } from "react-i18next";

const PlanChooseRow = ({handlePickPlan, whichPlan, slotsUsed}) => {
  const { t } = useTranslation();

  // A RadioButton shows as 'selected' when its 'isChecked' attribute is true.
  // The only RadioButton whose 'isChecked' attribute is true will be the one
  // whose 'planName', e.g. 'monthly3us300', matches the value in 'whichPlan'.
  // Clicking a RadioButton runs 'handlePickPlan' with the plan's 'planName',
  // causing 'isChecked' to be true for the clicked RadioButton.

  const handleWeekly3Change = () => {
    handlePickPlan('weekly3us200');
  };
  const handleMonthly3Change = () => {
    handlePickPlan('monthly3us300');
  };
  const handleBiannual3Change = () => {
    handlePickPlan('biannual3us1300');
  };
  const handleWeekly5Change = () => {
    handlePickPlan('weekly5us325');
  };
  const handleMonthly5Change = () => {
    handlePickPlan('monthly5us500');
  };
  const handleBiannual5Change = () => {
    handlePickPlan('biannual5us1900');
  };
  const handleWeekly8Change = () => {
    handlePickPlan('weekly8us525');
  };
  const handleMonthly8Change = () => {
    handlePickPlan('monthly8us800');
  };
  const handleBiannual8Change = () => {
    handlePickPlan('biannual8us2900');
  };

  const { planParticulars } = usePhrasing();

  const limits_3_weekly = planParticulars({
    maxTrips:       Constants.MAX_PLAN_TRIPS_3,
    maxOrders:      Constants.MAX_PLAN_OITEMS_3,
    maxSkuSearches: Constants.MAX_PLAN_SKU_SEARCHES_WEEKLY_3,
    period: t('global.weekly')
  });
  // Hold 100 Trips and 2000 OrderItems // Make 100 Sku Searches weekly

  const limits_3 = planParticulars({
    maxTrips:       Constants.MAX_PLAN_TRIPS_3,
    maxOrders:      Constants.MAX_PLAN_OITEMS_3,
    maxSkuSearches: Constants.MAX_PLAN_SKU_SEARCHES_3
  });
  // Hold 100 Trips and 2000 OrderItems // Make 500 Sku Searches monthly

  const limits_5_weekly = planParticulars({
    maxTrips:       Constants.MAX_PLAN_TRIPS_5,
    maxOrders:      Constants.MAX_PLAN_OITEMS_5,
    maxSkuSearches: Constants.MAX_PLAN_SKU_SEARCHES_WEEKLY_5,
    period: t('global.weekly')
  });
  // Hold 120 Trips and 3000 OrderItems // Make 150 Sku Searches weekly

  const limits_5 = planParticulars({
    maxTrips:       Constants.MAX_PLAN_TRIPS_5,
    maxOrders:      Constants.MAX_PLAN_OITEMS_5,
    maxSkuSearches: Constants.MAX_PLAN_SKU_SEARCHES_5
  });
  // Hold 120 Trips and 3000 OrderItems // Make 750 Sku Searches monthly

  const limits_8_weekly = planParticulars({
    maxTrips:       Constants.MAX_PLAN_TRIPS_8,
    maxOrders:      Constants.MAX_PLAN_OITEMS_8,
    maxSkuSearches: Constants.MAX_PLAN_SKU_SEARCHES_WEEKLY_8,
    period: t('global.weekly')
  });
  // Hold 140 Trips and 5000 OrderItems // Make 200 Sku Searches weekly

  const limits_8 = planParticulars({
    maxTrips:       Constants.MAX_PLAN_TRIPS_8,
    maxOrders:      Constants.MAX_PLAN_OITEMS_8,
    maxSkuSearches: Constants.MAX_PLAN_SKU_SEARCHES_8
  });
  // Hold 140 Trips and 5000 OrderItems // Make 1000 Sku Searches monthly

  const choosePlanTippyContent = t('circle.pick_a_plan.tippyContent010',
            {what_is_refund_policy: t('faq.refundPolicy.title020')})

  const planLimitsTippyContent = t(
    'circle.pick_a_plan.tippyContent040',
    {max_plan_skus: Constants.MAX_PLAN_SKUS}
  );

  return (
    <tr>
      <td>
        <HeadingBuilder
          containerType='container-input-label'
          headingText = {t('circle.pick_a_plan.label')}
          // Choose a Plan
          labelHtmlFor = "pick_a_plan"
          tippyText      = {Constants.DOT}
          tippyAlertText = {choosePlanTippyContent}
          tippyInfoText  = {planLimitsTippyContent}
        />
      </td>
      <td>
    { slotsUsed <= 3
      ? <>
        <RadioButton
          key="74"
          label={t('circle.planPriceBasic.label_3')}
          //" Up to 3 Shoppers, Weekly - $2.00"
          tippyAlert={limits_3_weekly}
          onChange={handleWeekly3Change}
          isChecked={whichPlan === 'weekly3us200'}
        />
        <RadioButton
          key="76"
          label={t('circle.planPriceBasic.label_3_1')}
          // " Up to 3 Shoppers, Monthly - $3.00"
          tippyAlert={limits_3}
          tippyInfo={t('circle.planPriceBasic.tippyContent_3_1')}
          // "Pay for 1.5 Weeks and get 2.8 Weeks free"
          onChange={handleMonthly3Change}
          isChecked={whichPlan === 'monthly3us300'}
        />
        <RadioButton
          key="78"
          label={t('circle.planPriceBasic.label_3_6')}
          // " Up to 3 Shoppers, 6 Months - $13.00"  // 4.3 * $3
          tippyAlert={limits_3}
          tippyInfo={t('circle.planPriceBasic.tippyContent_3_6')}
          // "Pay for 4.3 Months and get 1.7 Months free"
          onChange={handleBiannual3Change}
          isChecked={whichPlan === 'biannual3us1300'}
        />
        <hr />
        </>
      : null
    }
    { slotsUsed <= 5
      ? <>
        <RadioButton
          key="79"
          label={t('circle.planPriceBasic.label_5')}
          //" Up to 5 Shoppers, Weekly - $3.25"
          tippyAlert={limits_5_weekly}
          onChange={handleWeekly5Change}
          isChecked={whichPlan === 'weekly5us325'}
        />
        <RadioButton
          key="80"
          label={t('circle.planPriceBasic.label_5_1')}
          // " Up to 5 Shoppers, Monthly - $5.00"
          tippyAlert={limits_5}
          tippyInfo={t('circle.planPriceBasic.tippyContent_3_1')}
          // "Pay for 1.5 Weeks and get 2.8 Weeks free"
          onChange={handleMonthly5Change}
          isChecked={whichPlan === 'monthly5us500'}
        />
        <RadioButton
          key="90"
          label={t('circle.planPriceBasic.label_5_6')}
          // " Up to 5 Shoppers, 6 Months - $19.00"  // 3.8 * $5
          tippyAlert={limits_5}
          tippyInfo={t('circle.planPriceBasic.tippyContent_5_6')}
          // "Pay for 3.8 Months and get 2.2 Months free"
          onChange={handleBiannual5Change}
          isChecked={whichPlan === 'biannual5us1900'}
        />
        <hr />
        </>
      : null
    }
    { slotsUsed <= 8
      ? <>
        <RadioButton
          key="95"
          label={t('circle.planPriceBasic.label_8')}
          //" Up to 8 Shoppers, Weekly - $5.25"
          tippyAlert={limits_8_weekly}
          onChange={handleWeekly8Change}
          isChecked={whichPlan === 'weekly8us525'}
        />
        <RadioButton
          key="100"
          label={t('circle.planPriceBasic.label_8_1')}
          // " Up to 8 Shoppers, Monthly - $8.00"
          tippyAlert={limits_8}
          tippyInfo={t('circle.planPriceBasic.tippyContent_3_1')}
          // "Pay for 1.5 Weeks and get 2.8 Weeks free"
          onChange={handleMonthly8Change}
          isChecked={whichPlan === 'monthly8us800'}
        />
        <RadioButton
          key="110"
          label={t('circle.planPriceBasic.label_8_6')}
          // " Up to 8 Shoppers, 6 Months - $29.00"  // 3.6 * $8
          tippyAlert={limits_8}
          tippyInfo={t('circle.planPriceBasic.tippyContent_8_6')}
          // "Pay for 3.6 Months and get 2.4 Months free"
          onChange={handleBiannual8Change}
          isChecked={whichPlan === 'biannual8us2900'}
        />
        </>
      : null
    }
      </td>
    </tr>
  )
}

export default PlanChooseRow;